import type { ReactNode } from 'react'
import { useFormatNumber } from 'core/hooks/useFormatNumber'
import { roundProgressionForDisplay } from 'core/utils/round-progression-for-display'

interface AccountInfoProps {
  title: ReactNode
  value: number | null
  progression: number | null
  formatValue: (value: number) => string
  focusOnValue?: boolean
}

const AccountInfo = ({ title, value, progression, formatValue, focusOnValue = false }: AccountInfoProps) => {
  const formatNumber = useFormatNumber()
  const progressionRounded = roundProgressionForDisplay(progression)

  return (
    <div className="mg-channels-account-info">
      <div className="mg-channels-account-info-title vp-body-s">{title}</div>
      <div className="mg-channels-account-info-values">
        <div
          className={`mg-channels-account-info-values-value vp-body-m ${focusOnValue ? 'mg-channels-account-info-values-value-focus' : ''}`}
        >
          {formatValue(value)}
        </div>
        <div
          className={`mg-channels-account-info-values-progression vp-body-s ${
            progressionRounded != null
              ? progressionRounded < 0
                ? 'mg-channels-account-info-values-progression-decrease'
                : 'mg-channels-account-info-values-progression-increase'
              : ''
          }`}
        >
          {formatNumber(progressionRounded, '--', {
            style: 'percent',
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
            signDisplay: 'exceptZero'
          })}
        </div>
      </div>
    </div>
  )
}

export default AccountInfo
